export enum ComponentType {
  MESSAGE_EMPTY_STATE_COMPONENT = 0,
  MESSAGE_THREAD_COMPONENT = 1
}
